  <template>
  <div class="hddose">
    <h3>Intermittent Hemodialysis dosing algorithm</h3>
    <h4 class="title">Loading dose </h4>
    <ul id="input">
      <li>
        TBW
        <input type="range" min="35" max="100" step="1" v-model="tbw">
        <input class="input" type="integer" v-model="tbw" size="3px"> kg
      </li>
      
      <li id="dose">
        Loading dose : {{lddose}}
<div id="warning">(20 - 25 mg/kg; max 2,000 mg)</div>
        
      </li>
      <li>🎯 pre-HD trough : 15 - 20 mcg/ml</li>
    </ul>
    <br>
     <h4 class="title">Supplemental vancomycin dose </h4>
    <ul ul id="input">
      <li>
        TBW
        <input type="range" min="35" max="100" step="1" v-model="tbw">
        <input class="input" type="integer" v-model="tbw" size="3px"> kg
      </li>
      <li>
        pre-HD level*
        <input type="range" min="0" max="60" step="1" v-model="level">
        
        <input class="input" type="integer" v-model="level" size="4px">mcg/ml
      </li>
    </ul>
    <div id="result" v-show="level<10">Pre-HD level น้อยกว่า 10 mcg/ml
      <br>
      <img src="../assets/ivdrip.png" height="40px"> {{dosecalc10}}
    </div>
    <div id="result" v-show="level>=10 && level<15">Pre-HD level 10 - 15 mcg/ml
      <br>
      <img src="../assets/ivdrip.png" height="40px"> {{dosecalc1015}}
    </div>
    <div id="result" v-show="level>=15 && level<20">Pre-HD level 15 - 20 mcg/ml
      <br>
      <img src="../assets/ivdrip.png" height="40px"> {{dosecalc1520}}
    </div>
    <div id="result" v-show="level>=20 && level<25">Pre-HD level 20 - 25 mcg/ml
      <br>
      <img src="../assets/ivdrip.png" height="40px"> {{dosecalc2025}}
    </div>
    <div id="result" v-show="level>=25">
      Pre-HD level > 25 mcg/ml
      <br>hold vancomycin จนกระทั่งระดับยาอยู่ในเป้าหมาย
      โดยเจาะวัดระดับยา 4 - 6 ชั่วโมง หลังจากทำ HD ครั้งถัดไป
      ถ้า level น้อยกว่า 20 - 25 mcg/ml จึงกลับมาให้ยาต่อ
    </div>
    <ul >
      <li>*ถ้าไม่สามารถเจาะเลือด 30 นาทีก่อนทำ HD ได้ อาจเจาะภายในช่วงเช้าวันที่ทำ HD</li>
      <li>ในเคสที่ติดเชื้อรุนแรงอาจพิจารณาเพิ่มขนาดยา 20% ใน dose ก่อนทำ HD เพิ่อป้องกัน underdosing ระหว่างทำ HD</li>
      <li><a href="https://www.facebook.com/KeepMovingPharmacist/photos/a.2655827994491847/3945507278857239/">Ref: Intermittent Hemodialysis dosing algorithm</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "hddose",
  data() {
    return {
      tbw: 50,
      level: 20
    };
  },
  computed: {
    lddose() {
      return (
        Math.round((15 * this.tbw) / 50) * 50 +
        " - " +
        Math.round((20 * this.tbw) / 50) * 50 +
        " mg "
      );
    },
    dosecalc2025() {
      return (
        Math.round((2.5 * this.tbw) / 50) * 50 + " mg post HD หรือ hold 1 dose"
      );
    },
    dosecalc1520() {
      return Math.round((5 * this.tbw) / 50) * 50 + " mg post HD ";
    },
    dosecalc1015() {
      return (
        Math.round((7.5 * this.tbw) / 50) * 50 +
        " - " +
        Math.round((10 * this.tbw) / 50) * 50 +
        " mg post HD"
      );
    },
    dosecalc10() {
      return (
        Math.round((10 * this.tbw) / 50) * 50 +
        " - " +
        Math.round((15 * this.tbw) / 50) * 50 +
        " mg post HD"
      );
    }
  }
};
</script>

<style scope>
h3{
  font-size: 24px;
}
div#result {
  font-size: 18px;
  color: black;
  background-color: #fccbcb;
  margin-left: 2px;
}
ul#input li {
  display: list-item;
  list-style-type: none;
}
li#dose{
  background-color: #fccbcb;
}
li#warning{
  list-style-type: decimal;
}
.input {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #364f6b;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px thin #4f9bb2;
}

</style>

